import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledBadge = styled.span `
    padding: 0 7px;
    color: white;
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    height: 20px;
    border-radius: 10px;
    background-color: ${props => props.theme.secondary};
    line-height: 1.1rem;
`;
const Badge = ({ children, ...props }) => (_jsx(StyledBadge, { ...props, children: children }));
export default Badge;
